import React from 'react';

const TimeFilterButtons = ({ timeInterval, setTimeInterval }) => (
  <div className="btn-group mb-3" role="group">
    {['today', 'last_24h', 'last_48h', 'last_week', 'last_month', 'last_year'].map((interval) => (
      <button
        key={interval}
        type="button"
        className={`btn ${timeInterval === interval ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => setTimeInterval(interval)}
      >
        {interval.replace('_', ' ').replace('last ', 'Last ').replace('today', 'Today')}
      </button>
    ))}
  </div>
);

export default TimeFilterButtons;
